//#region src/tenants/hhb/routing.ts
/**
* HHB provider ranking — sequential-overwrite matching historical
* searchProviders sorts.
*
* Duplicate this object into other tenant files rather than importing it so
* Skylight/Demo can diverge without editing HHB. Agent workflow rules live in
* packages/services/src/harnesses/hhb/workflow.ts.
*/
const hhbProviderRouting = {
	ranking: {
		mode: "sequentialOverwrite",
		pipeline: [
			"insurance",
			"location",
			"providerName",
			"organizationName"
		]
	},
	nearbyTowns: [
		{
			a: "Marfa",
			b: "Fort Davis",
			state: "TX",
			roadMiles: 21
		},
		{
			a: "Marfa",
			b: "Alpine",
			state: "TX",
			roadMiles: 26
		},
		{
			a: "Marfa",
			b: "Marathon",
			state: "TX",
			roadMiles: 57
		},
		{
			a: "Marfa",
			b: "Presidio",
			state: "TX",
			roadMiles: 60
		},
		{
			a: "Marfa",
			b: "Van Horn",
			state: "TX",
			roadMiles: 74
		},
		{
			a: "Marfa",
			b: "Fort Stockton",
			state: "TX",
			roadMiles: 92
		},
		{
			a: "Marfa",
			b: "Pecos",
			state: "TX",
			roadMiles: 96
		},
		{
			a: "Alpine",
			b: "Fort Davis",
			state: "TX",
			roadMiles: 24
		},
		{
			a: "Alpine",
			b: "Marathon",
			state: "TX",
			roadMiles: 31
		},
		{
			a: "Alpine",
			b: "Fort Stockton",
			state: "TX",
			roadMiles: 66
		},
		{
			a: "Alpine",
			b: "Terlingua",
			state: "TX",
			roadMiles: 83
		},
		{
			a: "Alpine",
			b: "Presidio",
			state: "TX",
			roadMiles: 86
		},
		{
			a: "Alpine",
			b: "Van Horn",
			state: "TX",
			roadMiles: 100
		},
		{
			a: "Fort Davis",
			b: "Marathon",
			state: "TX",
			roadMiles: 55
		},
		{
			a: "Fort Davis",
			b: "Pecos",
			state: "TX",
			roadMiles: 75
		},
		{
			a: "Fort Davis",
			b: "Presidio",
			state: "TX",
			roadMiles: 81
		},
		{
			a: "Fort Davis",
			b: "Fort Stockton",
			state: "TX",
			roadMiles: 89
		},
		{
			a: "Fort Davis",
			b: "Van Horn",
			state: "TX",
			roadMiles: 95
		},
		{
			a: "Presidio",
			b: "Terlingua",
			state: "TX",
			roadMiles: 62
		},
		{
			a: "Terlingua",
			b: "Marathon",
			state: "TX",
			roadMiles: 98
		},
		{
			a: "Fort Stockton",
			b: "Pecos",
			state: "TX",
			roadMiles: 53
		},
		{
			a: "Fort Stockton",
			b: "Marathon",
			state: "TX",
			roadMiles: 58
		},
		{
			a: "Pecos",
			b: "Van Horn",
			state: "TX",
			roadMiles: 89
		}
	]
};

//#endregion
export { hhbProviderRouting };